<div
  [ngClass]="{ open: navService.sidebarState.sidenavOpen }"
  class="sidebar-left rtl-ps-none" tourAnchor="6"
  [perfectScrollbar]="{ suppressScrollX: true }"
>
  <div class="logo">
    <img src="./assets/images/logo.png" alt="" />
  </div>
  <div class="search-container">
    <div class="search-box">
      <div class="search-icon">
        <mat-icon>search</mat-icon>
      </div>
      <input style="text-align: center;" type="text" [placeholder]="'Search' | localize" [(ngModel)]="searchWord" (input)="onSearchInputChange()" />
      <button *ngIf="searchWord" class="clear-search-btn" (click)="clearSearch()">X</button>
    </div>
  </div>
  
  <ul class="navigation-left">
    <li
      [ngClass]="{ active: item.active }"
      (click)="onClickChangeActiveFlag(item)"
      class="nav-item lvl1"
      *ngFor="let item of nav; index as i"
    >
      <div
        class="nav-item-hold"
        routerLink="{{ item.state }}"
        (click)="closeChildNav()"
        *ngIf="item.type === 'link'"
      >
        <i [class]="'nav-icon ' + item.icon"></i>
        <span class="nav-text">{{ i + 1 }} - {{ item.name }}</span>
      </div>
      <div
        class="nav-item-hold"
        (click)="selectItem(item)"
        *ngIf="item.type === 'dropDown'"
      >
        <i [class]="'nav-icon ' + item.icon"></i>
        <span class="nav-text">{{ i + 1 }} - {{ item.name }}</span>
      </div>
      <div class="nav-item-hold" *ngIf="item.type === 'extLink'">
        <a [href]="item.state" target="_blank">
          <i [class]="'nav-icon ' + item.icon"></i>
          <span class="nav-text">{{ i + 1 }} - {{ item.name }}</span>
        </a>
      </div>

      <div class="triangle"></div>
    </li>
  </ul>
</div>

<div
  [ngClass]="{ open: navService.sidebarState.childnavOpen }"
  class="sidebar-left-secondary rtl-ps-none"
  [perfectScrollbar]="{ suppressScrollX: true }"
>
  <header>
    <h6>Apps</h6>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
  </header>
  <ng-container
    *ngTemplateOutlet="menuTemplate; context: { parentItem: selectedItem }"
  ></ng-container>
</div>

<ng-template #menuTemplate let-parentItem="parentItem" style="width: 300px">
  <ul class="childNav" appDropdown>
    <li
      *ngFor="let item of parentItem?.sub; index as i"
      appDropdownLink
      class="nav-item"
    >
      <a
        routerLink="{{ item.state }}"
        *ngIf="item.type === 'link'"
        class=""
        routerLinkActive="open"
      >
        <i *ngIf="item.icon" [class]="'nav-icon ' + item.icon"></i>
        <span class="item-name lvl1">{{ i + 1 }} - {{ item.name }}</span>
      </a>

      <div *ngIf="item.type === 'dropDown'">
        <a
          appDropdownToggle
          [ngClass]="{ open: item.active }"
          routerLinkActive="open"
        >
          <i *ngIf="item.icon" [class]="'nav-icon ' + item.icon"></i>
          <span class="item-name">{{ i + 1 }} - {{ item.name }}</span>
          <i class="dd-arrow imind-arrow-down"></i>
        </a>
        <ng-container
          *ngTemplateOutlet="menuTemplate; context: { parentItem: item }"
        ></ng-container>
      </div>
    </li>
  </ul>
</ng-template>

<div
  [ngClass]="{ open: navService.sidebarState.childnavOpen && navService.isChildMenuOpen }"
  class="sidebar-overlay"
  (click)="closeChildNav()"
></div>
<tour-step-template></tour-step-template>